__turbopack_context__.v({
  "__group-link": "group-list-module-scss-module__i74hcG____group-link",
  "__group-link-title": "group-list-module-scss-module__i74hcG____group-link-title",
  "__title": "group-list-module-scss-module__i74hcG____title",
  "group-list": "group-list-module-scss-module__i74hcG__group-list",
});
